export const TON_TICKER = 'TON';
